import {HTTP} from "../../helpers/axios";
// src/thunks.ts
import { Action } from 'redux'
import {RootState} from '../../reducers'
import { ThunkAction } from 'redux-thunk'
import { serverRoutes} from "../../api/serverRoutes";
import {responseData} from "../../dataInterface/deviceDetailInterface";


export const setCategoryAction = (data:object,callback:(error:boolean)=>void):ThunkAction<void, RootState, unknown, Action<string>> => async (dispatch,getState) => {

    const response=  await   HTTP(getState,dispatch).post(serverRoutes.setCategory,data);

    try {
        const response:responseData =  await   HTTP(getState,dispatch).post(serverRoutes.setCategory,{});

        let error=false;
        callback(error);

    }catch (e) {
        let error=true;
        callback(error);
    }

};
